import React, { useState, useEffect } from 'react';
import { getRequestOptions } from '../helpers/Fetchwrapper';
import { KTSVG } from '../../_metronic/helpers';
import {Table, Form } from 'react-bootstrap-v5';
import 'react-dropzone-uploader/dist/styles.css'
import { Link, useHistory, useLocation } from 'react-router-dom';
import Select from 'react-select';

const ALL_WAREHOUSE_OPTION = { label: 'All Warehouse', value: '' };

const ItemStockDetails: React.FC = () => {

    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const idItems: number = Number(query.get('id_items'));
    const idProjects: string = query.get('id_projects') || '';
    const idWarehouses: string = query.get('id_warehouses') || '';
    const fromDateParam = query.get('fromDate') || query.get('from_date') || '';
    const toDateParam = query.get('toDate') || query.get('to_date') || '';
    const [item, setItem] = useState<any>(null);
    const [warehouseName, setWarehouseName] = useState('');
    const [stockIn, setStockIn] = useState<any[]>([]);
    const [stockOut, setStockOut] = useState<any[]>([]);
    const [stockTransactions, setStockTransactions] = useState<any[]>([]);
    // Rate / Avg Rate columns; the backend sends rates only to roles with the View Stock Rates privilege
    const [canViewRates, setCanViewRates] = useState(false);
    const [typeSearch, setTypeSearch] = useState('');
    const [itemOptions, setItemOptions] = useState<any[]>([]);
    const [selectedItem, setSelectedItem] = useState<any>(null);
    const [warehouseOptions, setWarehouseOptions] = useState<any[]>([ALL_WAREHOUSE_OPTION]);

    const [formData, setFormData] = useState({
        id_projects: idProjects ? Number(idProjects) : 0,
        id_items: idItems,
        from_date: fromDateParam,
        to_date: toDateParam,
    });

    const getItems = async () => {
        try {
            const url = `${process.env.REACT_APP_API_URL}stock-details/items`;
            const response = await fetch(url, getRequestOptions());
            const data = await response.json();

            if (data.success && Array.isArray(data.data)) {
                const currentId = Number(new URLSearchParams(location.search).get('id_items'));
                const options = data.data.map((row: any) => ({
                    label: `${row.item_name}${row.item_code ? ` (${row.item_code})` : ''}${row.unit_name ? ` - ${row.unit_name}` : ''}`,
                    value: row.id_items,
                }));
                setItemOptions(options);
                setSelectedItem(options.find((option: any) => option.value === currentId) || null);
            } else {
                setItemOptions([]);
                setSelectedItem(null);
            }
        } catch (error) {
            console.error('Error fetching items:', error);
            setItemOptions([]);
            setSelectedItem(null);
        }
    };

    const getStockDetails = async () => {
        try {
            const currentQuery = new URLSearchParams(location.search);

            const queryParams = new URLSearchParams({
                id_projects: currentQuery.get('id_projects') || String(formData.id_projects || ''),
                id_items: currentQuery.get('id_items') || String(formData.id_items || ''),
                from_date: formData.from_date,
                to_date: formData.to_date,
            });
            const warehouseId = currentQuery.get('id_warehouses') || '';
            if (warehouseId) {
                queryParams.set('id_warehouses', warehouseId);
            }

            const url = process.env.REACT_APP_API_URL + 'stock-details?' + queryParams.toString();

            const response = await fetch(url, getRequestOptions());
            const data = await response.json();
            setItem(data.data.item);
            setWarehouseName(data.data.warehouseName || '');
            setStockIn(data.data.stockIn);
            setStockOut(data.data.stockOut);
            setStockTransactions(data.data.stockTransactions || []);
            setCanViewRates(Boolean(data.data.canViewRates));
            setTypeSearch('');
           
        } catch (error) {
            console.error('catch the hoop', error);
        }
    };
    
    const numberFormat = (value: number) => {
        return parseFloat(value.toString()).toLocaleString('en-US', {
            style: 'decimal',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    const formatRate = (value: any) => {
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        return parseFloat(Number(value).toFixed(4));
    };

    const getTransactionDetailPath = (row: any): string | null => {
        if (row.id_item_stock_adjustments) {
            return `/item-stock-adjustment-details/${row.id_item_stock_adjustments}`;
        }
        if (row.id_purchase) {
            return `/purchase-details/${row.id_purchase}`;
        }
        if (row.id_inv_opening_stocks) {
            return `/inventory-opening-details/${row.id_inv_opening_stocks}`;
        }
        if (row.id_inv_warehouse_transfers) {
            return `/warehouse-transfer-details/${row.id_inv_warehouse_transfers}`;
        }
        if (row.id_productions) {
            return `/manufacturing-details/${row.id_productions}`;
        }
        if (row.id_inv_issues) {
            return `/stock-issue-details/${row.id_inv_issues}`;
        }
        if (row.id_blending_orders) {
            return `/blending-order-details/${row.id_blending_orders}`;
        }
        if (row.id_packing_orders) {
            return `/packing-order-details/${row.id_packing_orders}`;
        }
        if (row.id_product_conversions) {
            return `/product-conversion-details/${row.id_product_conversions}`;
        }
        return null;
    };

    const renderDetailLink = (row: any, text: string) => {
        const detailPath = getTransactionDetailPath(row);
        if (!detailPath || !text || text === '-') {
            return text || '-';
        }
        return (
            <Link to={detailPath} target="_blank" rel="noopener noreferrer">
                {text}
            </Link>
        );
    };


    useEffect(() => {
        const currentQuery = new URLSearchParams(location.search);
        const nextIdItems = Number(currentQuery.get('id_items'));
        const nextIdProjects = currentQuery.get('id_projects') ? Number(currentQuery.get('id_projects')) : 0;

        setFormData((prev) => ({
            ...prev,
            id_items: nextIdItems,
            id_projects: nextIdProjects,
        }));
        setTypeSearch('');
        getStockDetails();
        getItems();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleItemChange = (selected: any) => {
        if (!selected?.value) {
            return;
        }

        const nextQuery = new URLSearchParams(location.search);
        nextQuery.set('id_items', String(selected.value));
        if (idProjects) {
            nextQuery.set('id_projects', idProjects);
        }
        if (idWarehouses) {
            nextQuery.set('id_warehouses', idWarehouses);
        }
        history.push(`/item-stock-details?${nextQuery.toString()}`);
    };

    const getWarehouses = async (projectId: string) => {
        if (!projectId) {
            setWarehouseOptions([ALL_WAREHOUSE_OPTION]);
            return;
        }
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}warehouse/${projectId}/list`, getRequestOptions());
            const data = await response.json();
            const options = data.success && Array.isArray(data.data)
                ? data.data.map((row: any) => ({ label: row.name, value: String(row.id_warehouses) }))
                : [];
            setWarehouseOptions([ALL_WAREHOUSE_OPTION, ...options]);
        } catch (error) {
            console.error('Error fetching warehouses:', error);
            setWarehouseOptions([ALL_WAREHOUSE_OPTION]);
        }
    };

    useEffect(() => {
        getWarehouses(idProjects);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idProjects]);

    const selectedWarehouse = warehouseOptions.find((option) => option.value === idWarehouses)
        || (idWarehouses ? { label: warehouseName || 'Selected Warehouse', value: idWarehouses } : ALL_WAREHOUSE_OPTION);

    const handleWarehouseChange = (selected: any) => {
        const nextQuery = new URLSearchParams(location.search);
        if (selected?.value) {
            nextQuery.set('id_warehouses', String(selected.value));
        } else {
            nextQuery.delete('id_warehouses');
        }
        history.push(`/item-stock-details?${nextQuery.toString()}`);
    };

    const handleViewReport = () => {
        getStockDetails();
    }

    const getExcelDownloadUrl = () => {
        const currentQuery = new URLSearchParams(location.search);
        const params = new URLSearchParams({
            id_projects: currentQuery.get('id_projects') || String(formData.id_projects || ''),
            id_items: currentQuery.get('id_items') || String(formData.id_items || ''),
            from_date: formData.from_date,
            to_date: formData.to_date,
        });
        const warehouseId = currentQuery.get('id_warehouses') || '';
        if (warehouseId) {
            params.set('id_warehouses', warehouseId);
        }
        // the download is a plain link: the token tells the backend who asks (rates need the View Stock Rates privilege)
        try {
            const token = JSON.parse(localStorage.getItem('MyToken') || 'null');
            if (token) {
                params.set('token', token);
            }
        } catch (error) {
            // no token: the file comes without rates
        }
        return `${process.env.REACT_APP_BACKEND}item_stock_details_download?${params.toString()}`;
    };

    const displayTransactions = stockTransactions.length
        ? stockTransactions
        : (() => {
            const fallbackTransactions = [
                ...stockIn.map((row) => ({
                    ...row,
                    in_qty: Number(row.quantity || 0),
                    out_qty: 0,
                    movement_order: 1,
                })),
                ...stockOut.map((row) => ({
                    ...row,
                    in_qty: 0,
                    out_qty: Number(row.quantity || 0),
                    movement_order: 2,
                })),
            ].sort((a, b) => {
                if (a.date === b.date) return a.movement_order - b.movement_order;
                return new Date(a.date).getTime() - new Date(b.date).getTime();
            });

            let runningBalance = 0;
            return fallbackTransactions.map((row) => {
                runningBalance += Number(row.in_qty || 0) - Number(row.out_qty || 0);
                return {
                    ...row,
                    balance_qty: runningBalance,
                };
            });
        })();

    const normalizedTypeSearch = typeSearch.trim().toLowerCase();
    const filteredByType = normalizedTypeSearch
        ? displayTransactions.filter((row) => (row.type || '').toLowerCase().includes(normalizedTypeSearch))
        : displayTransactions;

    const tableTransactions = normalizedTypeSearch
        ? (() => {
            let runningBalance = 0;
            return filteredByType.map((row) => {
                runningBalance += Number(row.in_qty || 0) - Number(row.out_qty || 0);
                return { ...row, balance_qty: runningBalance };
            });
        })()
        : filteredByType;

    const fullStockIn = displayTransactions.reduce((total, row) => total + Number(row.in_qty || 0), 0);
    const fullStockOut = displayTransactions.reduce((total, row) => total + Number(row.out_qty || 0), 0);
    const currentStock = fullStockIn - fullStockOut;

    const columnInSum = tableTransactions.reduce((total, row) => total + Number(row.in_qty || 0), 0);
    const columnOutSum = tableTransactions.reduce((total, row) => total + Number(row.out_qty || 0), 0);
    const filteredCurrentStock = columnInSum - columnOutSum;

    // Warehouse column only when viewing all warehouses
    const showWarehouseColumn = !idWarehouses;
    const extraCols = showWarehouseColumn ? 1 : 0;
    const rateCols = canViewRates ? 2 : 0;

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header'>
                    <div className="card-title">
                        <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                        <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                            Stock (In/Out) Details for {item?.itemName}
                        </span>
                    </div>
                    <div className="card-toolbar">
                        <div className='d-flex justify-content-end gap-2 align-items-end flex-wrap'>
                            <div style={{ minWidth: '260px' }}>
                                <Form.Label className='mb-1'>Change Item</Form.Label>
                                <Select
                                    value={selectedItem}
                                    onChange={handleItemChange}
                                    options={itemOptions}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    placeholder="Select Item"
                                />
                            </div>
                            <div style={{ minWidth: '200px' }}>
                                <Form.Label className='mb-1'>Warehouse</Form.Label>
                                <Select
                                    value={selectedWarehouse}
                                    onChange={handleWarehouseChange}
                                    options={warehouseOptions}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    placeholder="Select Warehouse"
                                    isDisabled={!idProjects}
                                />
                            </div>
                            <a
                                className="btn btn-sm btn-primary"
                                href={getExcelDownloadUrl()}
                                title="Download Excel report"
                            >
                                <i className='fas fa-download'></i> Excel Download
                            </a>
                            <Link className="btn btn-info btn-sm" to={`/stock-status`}>
                                <KTSVG
                                    path='/media/svg/icons/Media/Back.svg'
                                    className='svg-icon-5 svg-icon'
                                />		Back to Inventory Stock Status List
                            </Link>
                        </div>
                    </div>
                </div>

                <div className='card-body'>
                    <div className="row">
                        <div className="col mb-2">
                            <p className='mb-0'><strong>Item Name:</strong> {item?.itemName}</p>
                            <p className='mb-0'><strong>Item Code:</strong> {item?.itemCode}</p>
                            <p className='mb-0'><strong>Item Category:</strong> {item?.item_category?.categoryName}</p>
                            <p className='mb-0'><strong>Unit:</strong> {item?.unit?.unitName}</p>
                            <p className='mb-0'><strong>Stock:</strong> {numberFormat(currentStock)}</p>
                            <p className='mb-0'><strong>Warehouse:</strong> {idWarehouses ? (warehouseName || '-') : 'All Warehouse'}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className='col-md-2'>
                            <Form.Group className="mb-3" controlId="from_date">
                                <Form.Label>From Date<span className='required'></span></Form.Label>
                                <Form.Control type="date" placeholder="From Date" name='from_date' value={formData.from_date} onChange={handleChange}  className='form-control-sm'/>
                            </Form.Group>
                        </div>
                        <div className='col-md-2'>
                            <Form.Group className="mb-3" controlId="to_date">
                                <Form.Label>To Date<span className='required'></span></Form.Label>
                                <Form.Control type="date" placeholder="To Date" name='to_date' value={formData.to_date} onChange={handleChange} className='form-control-sm'/>
                            </Form.Group>
                        </div>
                        <div className='col-md-2'>
                            <div className="form-control-sm ps-0 mt-7">
                                <button className='btn btn-sm btn-primary w-100 p-2' onClick={handleViewReport}>
                                    <span>GO</span>
                                </button>
                            </div>                                
                        </div>
                        <div className='col-md-2'>
                            <div className="form-control-sm ps-0 mt-7">
                                <a
                                    className='btn btn-sm btn-success w-100 p-2'
                                    href={getExcelDownloadUrl()}
                                    title="Download Excel with current filters"
                                >
                                    <i className='fas fa-file-excel'></i> Excel
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col">
                            {normalizedTypeSearch && (
                                <p className='text-muted small mb-2'>
                                    Showing <strong>{tableTransactions.length}</strong> of <strong>{displayTransactions.length}</strong> records
                                    {typeSearch.trim() && <> matching &quot;<strong>{typeSearch.trim()}</strong>&quot;</>}
                                </p>
                            )}
                            <Table striped bordered hover size="sm">
                                <thead className='table-light'>
                                    <tr>
                                        <th>Date</th>
                                        {showWarehouseColumn && <th>Warehouse</th>}
                                        <th>Type</th>
                                        <th>Ref. No</th>
                                        {canViewRates && <th className='text-center'>Rate </th>}
                                        {canViewRates && <th className='text-center' title='Item average rate on that date'>Avg Rate</th>}
                                        <th className='text-end'>In Qty</th>
                                        <th className='text-end'>Out Qty</th>
                                        <th className='text-end'>Balance Qty</th>
                                    </tr>
                                    <tr>
                                        <th colSpan={1 + extraCols}></th>
                                        <th className='p-2' style={{ minWidth: '160px' }}>
                                            <Form.Control
                                                type="text"
                                                size="sm"
                                                placeholder="Search type..."
                                                value={typeSearch}
                                                onChange={(e) => setTypeSearch(e.target.value)}
                                                className='form-control-sm'
                                            />
                                        </th>
                                        <th colSpan={4 + rateCols}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableTransactions.length === 0 ? (
                                        <tr>
                                            <td colSpan={6 + rateCols + extraCols} className='text-center text-muted py-4'>
                                                No records found for this type search.
                                            </td>
                                        </tr>
                                    ) : (
                                        tableTransactions.map((row, index) => (
                                            <tr key={`txn-${index}`}>
                                                <td>{row.date}</td>
                                                {showWarehouseColumn && <td>{row.warehouseName || '-'}</td>}
                                                <td>{renderDetailLink(row, row.type || '-')}</td>
                                                <td>{renderDetailLink(row, row.referenceNo || '-')}</td>
                                                {canViewRates && <td className='text-end'>{formatRate(row.rate)}</td>}
                                                {canViewRates && <td className='text-end'>{formatRate(row.avg_rate)}</td>}
                                                <td className='text-end'>{Number(row.in_qty) ? numberFormat(Number(row.in_qty)) : '-'}</td>
                                                <td className='text-end'>{Number(row.out_qty) ? numberFormat(Number(row.out_qty)) : '-'}</td>
                                                <td className='text-end'>{numberFormat(Number(row.balance_qty || 0))}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className='table-light'>
                                        <th colSpan={3 + rateCols + extraCols} className='text-end'><strong>Total</strong></th>
                                        <th className='text-end'><strong>{numberFormat(columnInSum)}</strong></th>
                                        <th className='text-end'><strong>{numberFormat(columnOutSum)}</strong></th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <th colSpan={5 + rateCols + extraCols} className='text-end'><strong>Total Stock In</strong></th>
                                        <th className='text-end'><strong>{numberFormat(columnInSum)}</strong></th>
                                    </tr>
                                    <tr>
                                        <th colSpan={5 + rateCols + extraCols} className='text-end'><strong>Total Stock Out</strong></th>
                                        <th className='text-end'><strong>{numberFormat(columnOutSum)}</strong></th>
                                    </tr>
                                    <tr>
                                        <th colSpan={5 + rateCols + extraCols} className='text-end'><strong>Current Stock</strong></th>
                                        <th className='text-end'><strong>{numberFormat(normalizedTypeSearch ? filteredCurrentStock : currentStock)}</strong></th>
                                    </tr>
                                </tfoot>
                            </Table>
                        </div>
                    </div>
                    

                    <div className='row'>
                        <div className='col text-center'>

                            <Link className="btn btn-info btn-sm" to={`/stock-status`}>
                                <KTSVG
                                    path='/media/svg/icons/Media/Back.svg'
                                    className='svg-icon-5 svg-icon'
                                />		Back to Inventory Stock Status List
                            </Link>

                        </div>
                    </div>
                </div>
                
            </div>
            
        </>
    )
}

export default ItemStockDetails
